/* wellio-pdp.js v5 (23/09) - buy box GLP-1 Optimal
   1. An badge "Flash Sale" (do custom CSS cua Appstle sinh ra)
   2. Dong quyen loi duoi o Subscribe - theo chinh sach ship tung goi
   3. Gia moi chai tren tile (1 chai = gia le, 3 chai = gia sub + SAVE %)
   4. Badge SAVE cua Appstle tinh lai so voi gia goc 1 chai
   5. (moi) Chon SO LUONG cho goi 1 chai
   6. (moi) Doi chu "Free Shipping on Subscription" o chan buy box -> chi goi 3 chai

   !! KHONG GAN CUNG GIA (bai hoc 18/09 - muc S state_glp1_store): v2 gan cung 74.99 roi
   ha gia -> tile hien sub 1 chai DAT HON mua le, sub 1 chai tut ve 0.
   Tu v5: ca gia mua 1 lan LAN gia sub deu doc tu /products/glp-1-optimal.js
   (variants[].price + variants[].selling_plan_allocations[].price). Doi gia trong admin
   hay doi % trong Appstle -> PDP tu dung, KHONG can sua file nay.
   Chua doc xong / doc loi -> tile chi hien ten goi, KHONG hien so nao (thieu con hon sai).

   QUAN TRONG ve layout: .variant-content la FLEX ROW [anh][title].
   Gia + badge phai nam BEN TRONG <p class="variant-title"> (xep doc), row chi 2 cot. */
(function () {
  'use strict';

  var HANDLE = 'glp-1-optimal';
  var REF = '42375684915261';                 /* 1 chai = moc so sanh SAVE */
  var PACKS = {
    '42375684915261': { n: 1, label: '1 Bottle' },
    '42375684980797': { n: 3, label: '3 Bottles' }
  };
  /* Chinh sach ship (Son 23/09): sub 1 chai TRA ship, sub 3 chai free ship.
     Variant khong nam day (Akkermansia, Fiber...) giu nguyen "Free shipping". */
  var NO_FREE_SHIP_SUB = { '42375684915261': true };
  var QTY_VARIANT = '42375684915261';          /* chi goi 1 chai co chon so luong */
  var QTY_MAX = 6;

  var ON_PDP = location.pathname.indexOf('/products/' + HANDLE) !== -1;
  var LIVE = null;          /* { variantId: { once: $, sub: $|null } } - chi co sau khi fetch */
  var qty = 1;
  var busy = false;
  var timer = null;
  var lock = false;

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function money(v) { return '$' + v.toFixed(2); }
  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

  function syncPrices() {
    try {
      fetch(root() + 'products/' + HANDLE + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.variants) return;
          var m = {};
          d.variants.forEach(function (v) {
            if (!PACKS[String(v.id)] || typeof v.price !== 'number') return;
            var sub = null;
            (v.selling_plan_allocations || []).forEach(function (a) {
              if (typeof a.price === 'number' && (sub === null || a.price < sub)) sub = a.price;
            });
            m[String(v.id)] = { once: v.price / 100, sub: sub === null ? null : sub / 100 };
          });
          if (m[REF]) { LIVE = m; render(); }
        })
        .catch(function () {});
    } catch (e) {}
  }

  function formOf(el) { return el && el.closest ? el.closest('form[action*="/cart/add"]') : null; }
  function widgetForm() { return formOf(document.querySelector('.appstle_sub_widget')); }

  function currentId(scope) {
    var f = scope || widgetForm();
    var inp = (f && f.querySelector('input[name="id"]')) || document.querySelector('input[name="id"]');
    return inp ? String(inp.value) : null;
  }

  function currentPlan(scope) {
    var f = scope || widgetForm();
    var r = (f && f.querySelector('input[name="selling_plan"]:checked')) ||
            document.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');
    return r && r.value ? String(r.value) : null;
  }

  /* 1. Chan badge Flash Sale */
  function killFlash() {
    if (document.getElementById('wellio-noflash')) return;
    var st = document.createElement('style');
    st.id = 'wellio-noflash';
    st.textContent = '.appstle_one_time_text::after,.appstle_one_time_text::before{content:none !important;display:none !important}';
    document.head.appendChild(st);
  }

  /* Style cho phan moi v5 - de trong JS de khoi phai ghi lai wellio-addons.css */
  function injectCss() {
    if (document.getElementById('wellio-v5-css')) return;
    var st = document.createElement('style');
    st.id = 'wellio-v5-css';
    st.textContent =
      '.wellio-unit[hidden]{display:none !important}' +
      '.wellio-qty{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:6px 12px;' +
        'margin:12px 0 4px;padding:10px 14px;border:1.5px solid #dfe2ee;border-radius:16px;background:#fff;' +
        "font-family:'Rethink Sans',sans-serif;color:#2e3192}" +
      '.wellio-qty[hidden]{display:none !important}' +
      '.wellio-qty__label{font-size:15px;font-weight:600}' +
      '.wellio-qty__ctl{display:inline-flex;align-items:center;border:1.5px solid #c9cbe8;border-radius:999px;overflow:hidden;background:#fff}' +
      '.wellio-qty__ctl button{width:40px;height:36px;border:0;background:transparent;font-size:20px;line-height:1;' +
        'color:#2e3192;cursor:pointer;-webkit-tap-highlight-color:transparent;font-family:inherit}' +
      '.wellio-qty__ctl button:disabled{opacity:.3;cursor:default}' +
      '.wellio-qty__val{min-width:26px;text-align:center;font-weight:700;font-size:16px}' +
      '.wellio-qty__sum{flex:1 0 100%;font-size:13px;color:#555}' +
      '.wellio-qty__sum[hidden]{display:none !important}';
    document.head.appendChild(st);
  }

  /* 2. Dong quyen loi duoi o Subscribe - doi theo goi dang chon */
  function perks() {
    var wrap = document.querySelector('.appstle_subscription_radio_wrapper');
    if (!wrap) return;
    var holder = wrap.parentElement || wrap;
    var d = holder.querySelector('.wellio-subperks');
    if (!d) {
      d = document.createElement('div');
      d.className = 'wellio-subperks';
      wrap.insertAdjacentElement('afterend', d);
    }
    var id = currentId();
    setText(d, NO_FREE_SHIP_SUB[id] ? 'Cancel anytime' : 'Free shipping · Cancel anytime');
  }

  /* 3. Tile chon pack. 20/09 (Son): tile KHONG doi theo Subscribe/Buy once.
       1 chai -> gia LE, khong badge (neo gia) - 3 chai -> gia SUB + SAVE % (gia tot nhat).
     23/09: badge chi con "SAVE 25%" - bo "- $41.24" vi trung so voi $41.24/bottle ngay tren
     (o dung -25% tren 3 chai, tien tiet kiem = 0.75 x gia 1 chai = gia/chai sau giam). */
  function tiles() {
    var list = document.querySelectorAll('.variant-item[data-variant-id]');
    if (!list.length) return;

    list.forEach(function (it) {
      var id = it.getAttribute('data-variant-id');
      var p = PACKS[id];
      if (!p) return;
      var title = it.querySelector('.variant-title');
      if (!title) return;

      var name = title.querySelector('.wellio-name');
      if (!name) {
        name = document.createElement('span');
        name.className = 'wellio-name';
        title.insertBefore(name, title.firstChild);
      }
      /* bo text node tran cua GemPages ("3 Bottles - Discount 20%") */
      var nodes = title.childNodes;
      for (var i = nodes.length - 1; i >= 0; i--) {
        if (nodes[i].nodeType === 3) title.removeChild(nodes[i]);
      }
      setText(name, p.label);

      var u = title.querySelector('.wellio-unit');
      if (!u) {
        u = document.createElement('span');
        u.className = 'wellio-unit';
        title.appendChild(u);
      }
      var b = title.querySelector('.wellio-save');
      if (!b) {
        b = document.createElement('span');
        b.className = 'wellio-save';
        title.appendChild(b);
      }

      var live = LIVE && LIVE[id];
      if (!live) { setText(u, ''); u.hidden = true; b.hidden = true; return; }

      var isRef = (id === REF);
      var total = (!isRef && live.sub !== null) ? live.sub : live.once;
      setText(u, money(total / p.n) + '/bottle');
      u.hidden = false;

      var listTotal = LIVE[REF].once * p.n;
      var pct = Math.round((1 - total / listTotal) * 100);
      if (!isRef && pct >= 1) { setText(b, 'SAVE ' + pct + '%'); b.hidden = false; }
      else { b.hidden = true; }
    });
  }

  /* 4. Badge SAVE cua Appstle tinh tren gia variant -> ghi de theo gia goc 1 chai x n.
        Dong Buy Once: tu dung badge neu co giam (sau 23/09 pack 3 mua le = gia goc -> an). */
  function badge() {
    if (!LIVE) return;
    var id = currentId();
    var p = PACKS[id];
    var live = LIVE[id];
    if (!p || !live) return;
    var listTotal = LIVE[REF].once * p.n;

    var b = document.querySelector('.appstle-save-badge:not(.wellio-once-badge)');
    if (b && live.sub !== null) {
      var pct = Math.round((1 - live.sub / listTotal) * 100);
      if (pct > 0) setText(b, 'SAVE ' + pct + '%');
    }

    var txt = document.querySelector('.appstle_one_time_text');
    if (!txt) return;
    var oncePct = Math.round((1 - live.once / listTotal) * 100);
    var wrap = txt.parentElement;
    if (!wrap.classList.contains('appstle-text-and-badge-wrapper')) {
      wrap = document.createElement('span');
      wrap.className = 'appstle-text-and-badge-wrapper';
      txt.parentNode.insertBefore(wrap, txt);
      wrap.appendChild(txt);
    }
    var ob = wrap.querySelector('.wellio-once-badge');
    if (oncePct >= 1) {
      if (!ob) {
        ob = document.createElement('span');
        ob.className = 'appstle-save-badge wellio-once-badge';
        wrap.appendChild(ob);
      }
      setText(ob, 'SAVE ' + oncePct + '%');
      ob.hidden = false;
    } else if (ob) {
      ob.hidden = true;
    }
  }

  /* 5. Chon so luong - chi goi 1 chai. qty = 1 -> nut ATC cua GemPages chay nhu cu (khong dung gi).
        qty >= 2 -> chan click ATC, tu goi cart/add.js voi dung quantity + selling_plan dang chon,
        roi mo cart drawer cua Dawn. Ly do khong sua input quantity an cua GemPages: khong biet
        chac nut GemPages co doc input do hay ghi de lai = 1. */
  function qtyUI() {
    if (!ON_PDP) return;
    var w = document.querySelector('.appstle_sub_widget');
    if (!w) return;
    var box = document.getElementById('wellio-qty');
    if (!box) {
      box = document.createElement('div');
      box.id = 'wellio-qty';
      box.className = 'wellio-qty';
      box.innerHTML =
        '<span class="wellio-qty__label">Quantity</span>' +
        '<div class="wellio-qty__ctl">' +
          '<button type="button" data-wellio-q="-1" aria-label="Decrease quantity">&minus;</button>' +
          '<span class="wellio-qty__val" aria-live="polite">1</span>' +
          '<button type="button" data-wellio-q="1" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<span class="wellio-qty__sum" hidden></span>';
    }
    /* Appstle thay node widget khi doi variant -> dat lai ngay sau widget moi */
    if (box.previousElementSibling !== w) w.insertAdjacentElement('afterend', box);

    var id = currentId();
    var show = (id === QTY_VARIANT);
    if (!show) qty = 1;
    box.hidden = !show;

    setText(box.querySelector('.wellio-qty__val'), String(qty));
    var btns = box.querySelectorAll('button[data-wellio-q]');
    btns[0].disabled = qty <= 1;
    btns[1].disabled = qty >= QTY_MAX;

    var sum = box.querySelector('.wellio-qty__sum');
    var live = LIVE && LIVE[id];
    if (show && qty > 1 && live) {
      var plan = currentPlan();
      var unit = (plan && live.sub !== null) ? live.sub : live.once;
      setText(sum, qty + ' × ' + money(unit) + ' = ' + money(unit * qty) + (plan ? ' per delivery' : ''));
      sum.hidden = false;
    } else {
      sum.hidden = true;
    }
  }

  function addMany(btn) {
    if (busy) return;
    var f = formOf(btn) || widgetForm();
    var id = currentId(f);
    var plan = currentPlan(f);
    var item = { id: Number(id), quantity: qty };
    if (plan) item.selling_plan = Number(plan);
    var drawer = document.querySelector('cart-drawer');

    busy = true;
    btn.style.opacity = '0.6';
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'add failed');
        if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: Number(id), sections: res.j.sections });
        } else {
          window.location.href = root() + 'cart';
        }
      })
      .catch(function (err) {
        var sum = document.querySelector('#wellio-qty .wellio-qty__sum');
        if (sum) { sum.textContent = 'Could not add to cart - please try again.'; sum.hidden = false; }
        try { console.warn('[wellio-pdp] add qty failed:', err && err.message); } catch (e) {}
      })
      .then(function () { busy = false; btn.style.opacity = ''; });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest ? e.target.closest('button[data-wellio-q]') : null;
    if (q) {
      e.preventDefault();
      qty = Math.min(QTY_MAX, Math.max(1, qty + Number(q.getAttribute('data-wellio-q'))));
      render();
      return;
    }
    if (!ON_PDP || qty < 2) return;
    var atc = e.target.closest ? e.target.closest('gp-product-button') : null;
    if (!atc) return;
    if (currentId(formOf(atc)) !== QTY_VARIANT) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    addMany(atc);
  }, true);

  /* 6. Chu chan buy box (text tinh GemPages): chi con goi 3 chai free ship.
        Chi tren PDP GLP-1 - trang Akkermansia/Fiber van free ship moi goi sub. */
  function footerCopy() {
    if (!ON_PDP) return;
    var ps = document.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      var t = (ps[i].textContent || '').replace(/ /g, ' ').trim();
      if (t === 'Free Shipping on All Subscriptions') {
        ps[i].textContent = 'Free Shipping on 3-Bottle Plan';
      } else if (t === 'Subscription') {
        var prev = ps[i].previousElementSibling;
        var pt = prev ? (prev.textContent || '').replace(/ /g, ' ').trim() : '';
        if (pt === 'Free Shipping on') ps[i].textContent = '3-Bottle Plan';
      }
    }
  }

  function render() {
    if (lock) return;
    lock = true;
    try { killFlash(); injectCss(); perks(); tiles(); badge(); qtyUI(); }
    catch (e) {}
    finally { setTimeout(function () { lock = false; }, 0); }
  }

  /* Appstle dung lai widget bat dong bo sau khi doi goi -> ban lai 3 nhip */
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(render, 120);
    setTimeout(render, 400);
    setTimeout(render, 900);
  }

  function boot() {
    if (!document.querySelector('.variant-item[data-variant-id]') &&
        !document.querySelector('.appstle_sub_widget')) return;

    render();
    syncPrices();
    footerCopy();
    document.addEventListener('click', schedule, true);
    document.addEventListener('change', schedule, true);

    try {
      new MutationObserver(function () { if (!lock) schedule(); })
        .observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked'] });
    } catch (e) {}

    var tries = 0;
    var iv = setInterval(function () { render(); footerCopy(); if (++tries > 12) clearInterval(iv); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
